import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {ThumbnailModule} from '../../thumbnail/thumbnail.module';
import {PipesModule} from '../../../core/pipes/pipes.module';
import {PostTypeEnum} from '../../../core/enums/post-type.enum';
import {EventShowTabsEnum} from '../../../features/event/event-show/event-show-tabs.enum';
import {PostViewModel} from '../post.view-model';

@Component({
  selector: 'app-post-source-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ThumbnailModule,
    PipesModule,
  ],
  templateUrl: './post-source-header.component.html',
  styleUrl: './post-source-header.component.scss'
})
export class PostSourceHeaderComponent {
  @Input() post: PostViewModel | null = null;
  @Input() showShareState = false;

  public readonly PostTypeEnum = PostTypeEnum;
  public readonly EventShowTabsEnum = EventShowTabsEnum;

  public stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  public get projectTargetLabel(): string {
    return this.post?.project?.displayVehicleIdentity || '';
  }

  public get collaborationProjectTargetLabel(): string {
    return this.post?.collaboration?.project?.displayVehicleIdentity
      || this.post?.collaboration?.project?.vehicle?.fullVehicleIdentity
      || '';
  }
}
